import { styled } from '@mui/material'

export const DialogButtons = styled('div')`
  align-items: center;
  display: flex;
  justify-content: center;
  flex-flow: column;
  margin-top: 27px;
`

export const DialogContent = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 40px;
`

export const DialogIcon = styled('img')`
  width: 64px;
`

export const DialogMessage = styled('div')`
  margin: 24px 0 0;
  text-align: center;
  width: 100%;
`
export const Link = styled('a')``
